<div class="Txt-Withdraw-Banks withdraw-dialog">
  <div class="paypal-header">
    <div class="paypal-text">{{ 'PAYOUT' | t }}</div>
    <div class="close-svg" (click)="closeDialog()"></div>
  </div>
  <div class="paypal-container">
    <div class="paypal-icon-container">
      <image-loader-utils [url]="'banktransfer'" extraClasses="icon  payment-methods-icon"></image-loader-utils>
    </div>
    <div class="paypal-balance-text">
      <h2>{{ 'Balance' | t }} {{ this._UserHelper.customerUser?.Balance }}</h2>
    </div>

    <form class="example-form" [formGroup]="banksDatas" style="margin-top: 20px">
      <div class="credit-input-container">
        <mat-form-field class="example-full-width" style="width: 100%">
          <mat-label>{{ 'Bank' | t }}</mat-label>
          <input type="text" placeholder="Pick one" aria-label="Number" matInput formControlName="bankList" [matAutocomplete]="auto" />
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option *ngFor="let x of bankList" [value]="x.Bank">
              {{ x.Bank }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <inputb3 [extraClass]="'amountInput'" fPlaceholder="Iban No" fInputType="text" formControlName="accountNo"></inputb3>
        <inputb3 [extraClass]="'amountInput'" fPlaceholder="{{ 'Name_Surname' | t }}" fInputType="text" formControlName="nameSurname" disabled></inputb3>
        <inputb3 [extraClass]="'amountInput'" fPlaceholder="{{ 'Amount' | t }}" fInputType="number" formControlName="banksAmount"></inputb3>
      </div>
    </form>
    <div class="confirm-button-container" *ngIf="banksDatas.valid; else noAmount" (click)="submitBanksData()">
      <div class="btn colored register-button save-changes-button confirm-button">
        <div class="btn-text">{{ 'Confirm' | t }}</div>
      </div>
    </div>
    <ng-template #noAmount>
      <div class="confirm-button-container">
        <div style="opacity: 0.5" class="btn colored register-button save-changes-button confirm-button opacity">
          <div class="btn-text">{{ 'Confirm' | t }}</div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
